<div class="UNFAPP-lvcls-curses-box grid UNFAPP-b-hght">
    <div class="top-lvcls-info-area">
        <div class="lvcls-mobhdng">{{courseData.title}}</div>
        <div class="lvcls-info-imgframe UNFAPP-corse-imgfrme">
            <img class="lvcls-info-imgframe-img UNFAPP-corse-imgfrme-img" src="{{courseData?.batchPicture?.length ? courseData?.batchPicture[0] : courseData?.batchPicture}}" (error)="_helper.profileImgError($event)" />
        </div>
        <div class="lvcls-info-rgtpart">
            <div class="lvcls-info-innr">
                <div class="UNFAPP-lvcls-grdcol">
                    <ul class="UNFAPP-lvcls-grdtm-lst-area">
                        <li>
                            <img src="assets/img/grade-cap.svg" class="grdtm-lst-img" /><span>Grade {{courseData.grade}}</span>
                        </li>
                        <li>
                            <img src="assets/img/clock-icon.svg" class="grdtm-lst-img" /><span>{{courseData.duration}} Hours</span>
                        </li>
                        <li>
                            <span class="grd-cls-nm">{{courseData.language}}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="btm-lvcls-info">
        <div class="btm-lvcls-innr">
            <ul class="UNFAPP-lvcls-sbjct-lst">
                <ng-container *ngFor="let subject of courseData.subjects">
                    <li *ngIf="subject && showScience && subject!='Physics' && subject!='Chemistry' && subject!='Biology'">
                        <img src="assets/img/subject-icons/{{getSubIcon(subject) | lowercase}}-icon.svg" class="sbjct-lst-img" />
                        <span>{{subject | titlecase}}</span>
                    </li>
                    <li *ngIf="subject && !showScience">
                        <img src="assets/img/subject-icons/{{getSubIcon(subject) | lowercase}}-icon.svg" class="sbjct-lst-img" />
                        <span>{{subject | titlecase}}</span>
                    </li>
                </ng-container>
                <ng-container *ngIf="(showScience && !(checkIfNonScienceSubjectExists(courseData?.subjects)))">
                    <li>
                        <img src="assets/img/subject-icons/{{getSubIcon('science') | lowercase}}-icon.svg" class="sbjct-lst-img" />
                        <span>Science</span>
                    </li>
                </ng-container>

            </ul>
            <div class="UNFAPP-lvcls-actncol revert">
                <button class="UNFAPP-lvcls-txtbtn UNFAPP-coursegap" *ngIf="!courseData?.isCourseSelected" (click)="navigateToCourseDetails(courseData.id)">COURSE DETAILS
                    <i class="fa fa-caret-right"></i>
                </button>
                <app-custom-button   type="button"
                [cta]="{name: !courseData?.isCourseSelected ?'ENROLL NOW' :'VIEW COURSE',
                     type: !courseData?.isCourseSelected ? 'enroll' :'viewcourse', dataType: dataType, data:courseData}" [fromLiveClassPage]="fromLiveClassPage"></app-custom-button>
            </div>
        </div>
    </div>
</div>
